module.exports = __webpack_public_path__ + "img/convenzione.6a780bcf.png";